import { fn } from "jquery";
import React, { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { connect, useDispatch, useSelector } from "react-redux";
import Spinner from "../../../Components/Spinner/Spinner";
import {
  getLocationByMenuDataAction,
  getMenuDataAction,
} from "../../../Store/Action/CreateAgents/UserAction";
// import { getMenuItems } from '../../Services/Actions/menuAction'
import $ from "jquery";
import { useParams } from "react-router";
import DataTable from "react-data-table-component";

const FilterComponent = ({ filterText, onFilter }) => (
  <>
    <div className="">
      <input
        id="search"
        type="text"
        className="form-control"
        placeholder="Search"
        aria-label="Search Input"
        value={filterText}
        onChange={onFilter}
        style={{ marginBottom: "30px", marginLeft: "-20px" }}
      />
    </div>
  </>
);

function Additem(props) {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);

  const [addedProdect, setAddedProduct] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const [notes, setNotes] = useState("");
  const [selectedItem, setSelectedItem] = useState("");
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const allMenuData = useSelector((state) => state.getMenuReducer.user.data);

  const LocationByMenu = useSelector(
    (state) => state.getLocationByMenu.getLocationByMenu.data
  );
  const imgDefault = (e) => {
    e.target.src = "/images/menu-placeholder.jpg";
    e.target.onerror = null;
  };

  useEffect(() => {
    setLoading(props.getLocationByMenu.loading);
    if (props.getLocationByMenu.success) {
      const data = props?.getLocationByMenu.data?.filter((e) => {
        return parseInt(e.status) == 1;
      });

      setItems([...data]);
      // selected pizza
      const selectedItem = data.map((e) => {
        const addedItem = props?.addedItem.find(
          (item) => item.menu_item_id === e._id || item?._id === e._id
        );
        return {
          id: e._id,
          quantity: addedItem === undefined ? 0 : addedItem.quantity,
          ordernote: addedItem === undefined ? "" : addedItem.ordernote,
        };
      });
      if (selectedItem.length !== 0) {
        const filterData = selectedItem.filter(
          (e) => parseInt(e.status) === 1 && e.is_pizza === 1
        );

        if (filterData.length !== 0) {
          const cheapestItem = filterData?.reduce((a, b) => {
            return a.price < b.price ? a : b;
          });
          props.setChepestPizzaItem({ ...cheapestItem, quantity: 1 });
        } else {
          const cheapestItem = selectedItem[0];
          props.setChepestPizzaItem({ ...cheapestItem, quantity: 1 });
        }
      }
      setAddedProduct([...selectedItem]);
    }
  }, [props.getLocationByMenu]);

  const handleOrderNote = (e) => {
    setNotes(e.target.value);
  };

  const handleAddItem = (id) => {
    const _item = addedProdect.map((e) => {
      if (e.id === id) {
        return {
          ...e,
          quantity: e.quantity + 1,
        };
      } else return e;
    });
    setAddedProduct([..._item]);
  };

  const handleRemoveItem = (id) => {
    const _item = addedProdect.map((e) => {
      if (e.id === id && e.quantity > 0) {
        return {
          ...e,
          quantity: e.quantity - 1,
          ordernote: e.quantity - 1 === 0 ? "" : e.ordernote,
        };
      } else return e;
    });

    setAddedProduct([..._item]);
  };

  const handleinput = (id, value) => {
    const _item = addedProdect.map((e) => {
      if (e.id === id) {
        return {
          ...e,
          quantity: value !== "" ? parseInt(value) : 0,
        };
      } else return e;
    });

    setAddedProduct([..._item]);
  };

  const handleCancel = () => {
    props.setIsAddItem(false);
  };

  const handleAddOrder = () => {
    const data = addedProdect
      .filter((e) => e.quantity > 0)
      .map((item) => {
        const _item = items.find((e) => e._id === item.id);
        return {
          ..._item,
          quantity: item.quantity,
          ordernote: item.ordernote,
          isfree: "0",
          menu_item_id: item.id,
        };
      });
    props.setAddedItem([...data]);
    props.setIsAddItem(false);
  };

  const columns = [
    {
      name: "Item Name",
      selector: (row) => row.item_name,
      sortable: true,
    },
    {
      name: "Price",
      selector: (row) => row.price,
      sortable: true,
      width:"200px"
    },
    // {
    //   name: "Image",
    //   // selector: (row) => row.image,
    //   sortable: true,
    //   cell: (row) => (
    //     <img
    //       crossOrigin="anonymous"
    //       onError={imgDefault}
    //       src={row?.image}
    //       height="70px"
    //       width="90px"
    //       className="m-3"
    //     />
    //   ),
    // },

    {
      name: "Action",
      selector: (row) => row.action,
      // width: "250px",
    },
  ];

  const handleAddNotes = (id) => {
    handleShow();
    setSelectedItem(id);
    const Order = addedProdect.find((e) => {
      return e.id === id;
    });
    const orederNote = !!Order.ordernote ? Order.ordernote : "";
    setNotes(orederNote);
  };

  const data = items?.map((data, i) => {
    return {
      id: data._id,
      image: data?.image ? data?.image : "N/A",
      item_name: data?.item_name ? data.item_name : "N/A",
      price: data?.price ? `${"$" + data?.price}` : "N/A",
      action: (
        <>
          <div className="d-flex">
            <button
              className="btn bg-red text-white py-1"
              onClick={() => handleRemoveItem(data._id)}
            >
              <span className="">-</span>
            </button>
            <input
              className="btn bg-red text-white py-1 mx-1"
              style={{ width: "35px" }}
              value={addedProdect?.find((e) => e.id === data._id)?.quantity}
              onChange={(e) => handleinput(data?._id, e.target.value)}
            />
            {props?.flag !== 1 && (
              <div
                className="btn bg-red text-white py-1"
                onClick={() => handleAddItem(data._id)}
              >
                +
              </div>
            )}
            {parseInt(addedProdect.find((e) => e.id === data._id)?.quantity) >
              0 && (
              <button
                className="btn bg-red text-white py-1 ms-1"
                // style={{ width: "35px", height:"30px" }}
                onClick={() => handleAddNotes(data._id)}
              >
                Add Note
              </button>
            )}

            {/* <div
              className="bg-red text-white rounded py-1 ms-3 px-3 pointer"
              onClick={() => handleAddNotes(data._id)}
            >
              +
            </div> */}
          </div>
        </>
      ),
    };
  });

  // const filteredItems = data?.filter(
  //   (item) =>
  //     filterText !== "" &&
  //     item.item_name.toLowerCase().includes(filterText.toLowerCase())
  // );

  const filteredItems = data?.filter((item) =>
    item.item_name.toLowerCase().includes(filterText.toLowerCase())
  );

  const subHeaderComponentMemo = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => setFilterText(e.target.value)}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle]);

  // $("#example").dataTable({
  //   language: {
  //     emptyTable: "No data available in table",
  //   },
  // });

  return (
    <>
      <Modal.Header closeButton className="">
        <Modal.Title>Add Item</Modal.Title>
      </Modal.Header>
      {loading ? (
        <Spinner />
      ) : (
        <Modal.Body style={{ height: "765px" }}>
          <div className="mt-3" style={{ overflowY: "auto" }}>
            <DataTable
              columns={columns}
              data={filteredItems}
              pagination
              subHeader
              subHeaderComponent={subHeaderComponentMemo}
              noDataComponent={"No item available"}
            />
          </div>
        </Modal.Body>
      )}
      <Modal.Footer className="mt-3">
        <div
          className="py-2 px-4 border rounded pointer text-white bg-red mx-2"
          onClick={handleAddOrder}
        >
          Add Item
        </div>
      </Modal.Footer>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Order Note</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-12 mt-2">
            <Form.Group className="mb-3 ">
              <Form.Label>Note:</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Note"
                name="note"
                label="note"
                value={notes}
                onChange={handleOrderNote}
                id="note"
                as="textarea"
                rows={3}
              />
            </Form.Group>
          </div>
          <div className="d-flex justify-content-end">
            <div
              className="border rounded pointer px-4 py-2 text-white bg-red"
              onClick={() => {
                const Order = addedProdect.map((e) => {
                  if (e.id === selectedItem) {
                    return {
                      ...e,
                      ordernote: notes,
                    };
                  } else return e;
                });
                setAddedProduct(Order);
                handleClose();
                setSelectedItem("");
                setNotes("");
              }}
            >
              Save
            </div>
          </div>
        </Modal.Body>
        {/* <Modal.Footer className="mt-3 ">
        </Modal.Footer> */}
      </Modal>
    </>
  );
}

const mapStateToProp = (state) => ({
  // loginReducer: state.AuthReducer.loginReducer
  getMenuReducer: state.getMenuReducer,
  getLocationByMenu: state.getLocationByMenu.getLocationByMenu,
  // updatedData: state.MenuItemsReducer.updateMenu,
  // deletedData: state.MenuItemsReducer.deleteMenu,
  // addMenuData: state.MenuItemsReducer.addMenu,
});

const mapDispatchToProps = (dispatch) => ({
  getMenuDataAction: (Details) => dispatch(getMenuDataAction(Details)),
  // deleteMenuItems: (id) => dispatch(deletemenuitem(id)),
  // resetUpdateMenuItems: () => dispatch({ type: RESET_UPDATE_MENU }),
  // resetAddMenuItems: () => dispatch({ type: RESET_ADD_MENU }),
  // resetDeleteMenuItems: () => dispatch({ type: RESET_DELETE_MENU }),
  // login: (details) => dispatch(adminLogin(details)),
  // resetLoginReducer: () => dispatch({ type: RESET_LOGIN }),
});

export default connect(mapStateToProp, mapDispatchToProps)(Additem);
